import navigation from '../components/navigation';

(function () {
  const menu = new navigation({
    navToggleId: '#burgerToggle',
    mobileNavigationId: '#mobileNav',
  });

  menu.scrollingBehavior();

  menu.mobileNavToggleHandler('burger--active', 'menu--active');

  menu.submenuNavToggleHandler({
    mainNavClassName: '.nav__subhead',
    mainNavActiveState: 'nav__subhead--open',
    subnavActiveState: 'subnav--active',
  });

})();